import React, { useState } from "react";
import BlogCMSForm from "../../components/BlogCMSForm";
import BlogsTable from "./BlogsTable";

const BlogTabs = () => {
  const [activeTab, setActiveTab] = useState("addBlog");

  return (
    <div>
      {/* Tab Headers */}
      <div className="flex flex-nowrap lg:overflow-visible lg:whitespace-normal overflow-x-auto whitespace-nowrap lg:pb-0 pb-2 space-x-4 lg:px-8 px-5">
        <button
          onClick={() => setActiveTab("addBlog")}
          className={`main-class px-8 py-2.5 rounded-full text-sm ${
            activeTab === "addBlog" ? "bg-blue-600 text-white border border-gray-500 shadow-[0px_6px_16px_0px_rgba(41,93,196,0.3)]" : "bg-white text-black"
          }`}
        >
          Add Blog
        </button>
        <button
          onClick={() => setActiveTab("blogs")}
          className={`main-class px-8 py-2.5 rounded-full text-sm ${
            activeTab === "blogs" ? "bg-blue-600 text-white border border-gray-500 shadow-[0px_6px_16px_0px_rgba(41,93,196,0.3)]" : "bg-white text-black"
          }`}
        >
          Blogs
        </button>
      </div>

      {/* Tab Content */}
      <div className="lg:pt-8 pt-5">
        {activeTab === "addBlog" ? (
          <BlogCMSForm />
        ) : (
          <div>
           <BlogsTable/>
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogTabs;
